import { AnchorLink, SectionHeading, Wrapper } from "@gw/component-library";
import React from "react";
import { UserCreateForm } from "../../components";
import { BaseLayout } from "../../layouts";
import { useParams } from "@reach/router";
import { EditUserPageStyled } from "./EditUserPageStyled";
var EditUserPage = function (props) {
    var userId = useParams().userId;
    return (React.createElement(BaseLayout, null,
        React.createElement(EditUserPageStyled, null,
            React.createElement(Wrapper, { className: "wrapper my-50" },
                React.createElement(AnchorLink, { to: "/admin/users" }, "< Back to User List"),
                React.createElement(SectionHeading, { className: "heading" }, "Edit User"),
                React.createElement(UserCreateForm, { userId: userId })))));
};
export default EditUserPage;
//# sourceMappingURL=EditUserPage.js.map